import axios from "axios";
import {
    isNumber,
    isArray,
    isObject,
    mapValues
} from "lodash";
import { store } from "./Store";
import { AppState } from "./Reducers/Reducers";

axios.interceptors.request.use((request) => {
    const state = store.getState() as AppState;
    if (
        !request.headers.get('X-Cms-Funnel') &&
        isNumber(state.page.circuit.funnelId) &&
        new URL(
            request.url?.startsWith('http') ?
                request.url :
                window.location.origin + request.url,
        ).origin === window.location.origin
    ) {
        request.headers.set('X-Cms-Funnel', state.page.circuit.funnelId);
    }

    if (request.url) {
        try {
            const url = new URL(
                request.url,
                !request.baseURL && !request.url.startsWith('http') ?
                    window.location.origin :
                    request.baseURL
            );

            if (url.pathname.endsWith('/instances/')) {
                request.url = request.url.replace('v1', 'v2');
            }

            if (location.pathname.includes('circuits-details')) {
                if (!request.params) {
                    request.params = {};
                }
                request.params['package_detail'] = true;
            }
        } catch (error) {
            if (!(error instanceof Error) || !error.message.includes('Invalid URL')) {
                console.error(error);
            }
        }
    }

    return request;
});

axios.interceptors.response.use((response) => {
    const request = response.config;
    if (request.url) {
        const url = new URL(
            request.url,
            !request.baseURL && !request.url.startsWith('http') ?
                window.location.origin :
                request.baseURL
        );

        if (
            url.pathname.endsWith('/custom-products/') &&
            request.method?.toUpperCase() === 'GET'
        ) {
            return {
                ...response,
                data: response.data.map((item: any) => {
                    if (item.product_type === 4) {
                        try {
                            const data = item.extra_information ?
                                JSON.parse(item.extra_information) :
                                null;
                            return {
                                ...item,
                                pickup_type: data?.pickup_type ?? null,
                                return_type: data?.return_type ?? null
                            }
                        } catch (error) {
                            console.error(error);
                        }
                    }
                    return item;
                })
            };
        }
    }
    return response;
}, (error) => {
    if (axios.isAxiosError(error)) {
        switch (error.response?.status) {
            case 429: {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        if (error.config) {
                            resolve(axios(error.config));
                        } else {
                            reject(error);
                        }
                    }, 3000);
                })
            }
        }
    }
    return Promise.reject(error);
});

function replaceUrlsWithCompressedPicture(data: unknown): unknown {
    if (isArray(data)) {
        return data.map((item) => {
            return replaceUrlsWithCompressedPicture(item);
        });
    }

    if (isObject(data)) {
        if (
            'compressed_picture' in data &&
            data.compressed_picture
        ) {
            if ('url' in data) {
                data.url = data.compressed_picture;
            }

            if ('thumbnail_big' in data) {
                data.thumbnail_big = data.compressed_picture;
            }

            if ('thumbnail_medium' in data) {
                data.thumbnail_medium = data.compressed_picture;
            }
        }

        return mapValues(
            data,
            (value) => replaceUrlsWithCompressedPicture(value)
        );
    }

    return data;
}

axios.interceptors.response.use((response) => {
    if (response.data && !(response.data instanceof Blob)) {
        return {
            ...response,
            data: replaceUrlsWithCompressedPicture(response.data)
        };
    }
    return response;
});